import { render, staticRenderFns } from "./multi-accordian.html?vue&type=template&id=30b9fa20&scoped=true&"
import script from "./multi-accordian.js?vue&type=script&lang=js&"
export * from "./multi-accordian.js?vue&type=script&lang=js&"
import style0 from "./multi-accordian.scss?vue&type=style&index=0&id=30b9fa20&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=30b9fa20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b9fa20",
  null
  
)

export default component.exports